import axios from 'axios';
import store from '@/store';

// Создание экземпляра axios с базовым URL
export const $axios = axios.create({
  baseURL: `${process.env.VUE_APP_BACKEND_URL}/api/v2/`,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const withAuth = () => ({
  headers: { Authentication: `Bearer ${store.getters.authToken}` },
});